import SET_SELLER from './types';
export default {
  setSeller: function setSeller(_ref, payload) {
    var commit = _ref.commit;
    commit(SET_SELLER, payload);
  }
};